/* client/src/pages/Settings/Security.js */
import React from 'react';
import { useNavigate } from 'react-router-dom';
import './Settings.css'; // Re-use settings styles

const Security = () => {
    const navigate = useNavigate();

    return (
        <div className="fade-in">
            <div className="settings-card">
                <h2>Login & Security</h2>
                <p className="card-desc">
                    Manage your password and account security settings.
                </p>

                {/* Password Row */}
                <div className="toggle-row">
                    <div className="toggle-info">
                        <h4>Password</h4>
                        <p>It's a good idea to use a strong password that you're not using elsewhere.</p>
                    </div>
                    <button
                        className="unblock-btn" // Re-using your existing button style
                        style={{ padding: '10px 20px', fontSize: '0.9rem' }}
                        onClick={() => navigate('/change-password')}
                    >
                        Change Password
                    </button>
                </div>

                {/* Placeholder for future 2FA */}
                {/* <div className="toggle-row">
                    <div className="toggle-info">
                        <h4>Two-Factor Authentication</h4>
                        <p>Add an extra layer of security to your account.</p>
                    </div>
                    <div className="toggle-switch off"><div className="toggle-slider"></div></div>
                </div> 
                */}
            </div>
        </div>
    );
};

export default Security;